<template>
  <v-container fluid>
    <v-row v-if="images.length">
      <v-col
        v-for="(image, index) in images"
        :key="index"
        cols="4"
        sm="3"
        md="2"
        lg="2"
        class="p-05"
        style="position: relative"
      >
        <div class="dd-container" ref="dropdown">
          <v-icon
            class="dots-v"
            dark
            @click="showMenuIndex = showMenuIndex === index ? null : index"
            v-if="personData.userId == currentUser.id"
          >
            mdi-dots-vertical
          </v-icon>
          <v-list dense class="pb-0 dd-list" v-if="showMenuIndex == index">
            <v-list-item dense @click="emitDeleteImage(image.id)">
              <v-list-item-title>{{
                lang.actions.deleteImage
              }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </div>
        <v-img
          :alt="'Image ' + image.id"
          :lazy-src="require('../../assets/images/lazy-loading.png')"
          :src="image.imageUrl"
          aspect-ratio="1"
          @click="emitImageShow(image.id, index)"
          style="cursor: pointer"
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-col>
    </v-row>
    <NoResult
      v-else
      class="mt-0"
      :show="true"
      :title="lang.profile.noData"
    ></NoResult>
  </v-container>
</template>

<script>
import NoResult from "../../components/noResult";
export default {
  data() {
    return {
      showMenuIndex: null,
    };
  },
  props: {
    images: {
      type: Array,
      default() {
        return [];
      },
    },
    personData: {
      type: Object,
      default() {
        return {};
      },
    },
    currentUser: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {
    NoResult,
  },
  computed: {
    lang() {
      return this.$store.state.langObj || {};
    },
  },
  methods: {
    emitImageShow(id, index) {
      this.$emit(
        "emitImageShow",
        this.$route.path.includes("demo") ? index : id
      );
    },
    emitDeleteImage(id) {
      this.showMenuIndex = null;
      this.$emit("emitDeleteImage", id);
    },
    handleClickOutside(event) {
      const dropdowns = this.$refs.dropdown;
      if (!dropdowns) return;
      const isOutsideClick = !Array.from(dropdowns).some((dropdown) =>
        dropdown.contains(event.target)
      );

      if (isOutsideClick) {
        this.showMenuIndex = null;
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style lang="scss" scoped>
.p-05 {
  padding: 1px;
}
.dd-container {
  position: absolute;
  right: 0;
  .dd-list {
    position: absolute;
    top: 35px;
    z-index: 5;
    right: 10px;
    padding-top: 0;
  }
}
.dots-v {
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 10px;
  z-index: 1;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  border: 1px solid #fff;
  border-radius: 4px;
}
</style>